// components/TrustedBy.tsx
"use client";

const partners = [
  { name: 'Agarwal Packers', color: '#1a365d' },
  { name: 'GATI', color: '#2d3748' },
  { name: 'Blue Dart', color: '#2b6cb0' },
  { name: 'DTDC', color: '#c53030' },
  { name: 'Safexpress', color: '#2f855a' },
  { name: 'VRL Logistics', color: '#6b46c1' },
  { name: 'Mahindra Logistics', color: '#d69e2e' },
  { name: 'Allcargo', color: '#2c5282' },
  { name: 'TCI', color: '#c05621' },
  { name: 'Ola Movers', color: '#38a169' },
];

export default function TrustedBy() {
  // Duplicate for seamless scroll
  const allPartners = [...partners, ...partners, ...partners];

  return (
    <section className="py-12 md:py-16 bg-gray-50 border-y border-gray-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h3 className="text-sm font-semibold text-[#292929] uppercase tracking-wider">
            Trusted by Industry Leaders
          </h3>
          <p className="text-[#343434] text-sm mt-1">
            Partnered with India's most trusted logistics brands
          </p>
        </div>

        {/* Logo Marquee */}
        <div className="relative">
          {/* Gradient fades */}
          <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 z-10 pointer-events-none bg-gradient-to-r from-gray-50 via-gray-50/80 to-transparent"></div>
          <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 z-10 pointer-events-none bg-gradient-to-l from-gray-50 via-gray-50/80 to-transparent"></div>

          <div className="overflow-hidden">
            <div className="flex gap-4 md:gap-6 items-center animate-scroll-logo">
              {allPartners.map((partner, index) => (
                <div
                  key={`${partner.name}-${index}`}
                  className="flex-shrink-0 opacity-70 hover:opacity-100 transition-all duration-300"
                >
                  <img
                    src={`https://placehold.co/120x50/${partner.color.replace('#', '')}/ffffff`}
                    alt={partner.name}
                    className="h-10 w-auto rounded-md"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer link */}
        <div className="text-center mt-8">
          <p className="text-xs text-[#343434]">
            Join 1,000+ businesses that trust Movezze for their relocation needs.{' '}
            <a
              href="/contact"
              className="text-[#343434] font-medium hover:text-[#f62b1e] transition-colors"
            >
              Become a partner →
            </a>
          </p>
        </div>
      </div>

      <style>{`
        @keyframes scrollLogo {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        .animate-scroll-logo {
          animation: scrollLogo 30s linear infinite;
          width: max-content;
        }
        .animate-scroll-logo:hover {
          animation-play-state: paused;
        }
        @media (max-width: 768px) {
          .animate-scroll-logo {
            animation-duration: 20s;
          }
        }
      `}</style>
    </section>
  );
}